<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Internal
    </button>

    <a-modal v-model="visible" title="Add an internal assessment">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="handleSubmit">Add Internal</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <a-form-item label="Name">
          <a-input
            placeholder="Name"
            v-decorator="['name', {rules: [{ required: true, message: 'Please input an internal name!' }, {max: 20, message: 'Must not exceed 20 characters!'}]}]"
          />
        </a-form-item>
        <a-form-item label="Description">
          <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description', {rules: [{max: 100, message: 'Must not exceed 100 characters!'}]}]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>

export default {
  name: 'AddInternal',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },

    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the new subject!`,
            onOk: () => {
              this.$http
                .post('/api/internal_assessment', {
                  name: values.name,
                  description: values.description,
                })
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Subject successfully added',
                    description: `${data.data.name} added successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
